module.exports = "/images/agent-onboarding-2.png?ec1da46b799663f5bfb03e8905efcf68";